<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="costs">
      <p class="sub_title">
        服务目的
      </p>
      <div class="content_A">
        <div>
          通过制定单位信息安全体系， 建立和制定科学、
          高效的信息安全管理组织及制度，
          通过信息安全管理对信息安全风险进行识别、 分析，
          并采取措施将风险降到可接受水平并维持该水平；实现规范人员的行为，
          保证各种网络安全技术手段的有效实施， 从整体上统筹安排各种软硬件，
          使信息安全体系能够实现落地， 保证信息安全体系协同工作的高效、
          有序和经济性， 最终发挥信息安全体系的作用和价值。
        </div>
      </div>
    </div>
    <div class="costs bg_color">
      <p class="sub_title">
        设计理念
      </p>
      <div class="content_A">
        <div>
          信息安全体系规划设计按照ISO/IEC
          27001信息安全体系标准和网络安全等级保护规定要求，
          做好相应的结合点设计与建设， 覆盖人员组织、 管理、 技术三个领域。
          通过对信息安全体系的研究， 实践并规范信息安全风险评估方法、
          技术监测监管、 应急响应机制， 为客户完成信息安全体系规划设计。
        </div>
        <div class="content_img">
          <div class="bg_img">
            <div>管理因素</div>
            <div>技术因素</div>
            <div>人员组织因素</div>
          </div>
        </div>
      </div>
    </div>
    <div class="costs">
      <p class="sub_title">
        服务流程
      </p>
      <div class="content_A">
        <div>
          <img
            src="@/assets/securityServices/planning4.png"
            alt=""
          >
        </div>
      </div>
    </div>
    <div class="introduces">
      <p class="sub_title">
        实施方法
      </p>
      <div class="lists">
        <div
          v-for="item in introduceList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <div class="img">
              <img
                :src="item.img"
                alt=""
              >
            </div>
            <div class="title">
              {{ item.title }}
            </div>
            <div class="line">
              {{ item.name }}
            </div>
            <div class="content">
              <div
                v-for="list in item.list"
                :key="list"
              >
                {{ list }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="costs">
      <p class="sub_title">
        服务价值
      </p>
      <div class="content_P">
        <div
          v-for="fwjz in fwjzList"
          :key="fwjz.id"
        >
          <li>{{ fwjz.content }}</li>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Planning',
  components: {
    banner
  },
  data() {
    return {
      title: '安全体系规划设计服务',
      content:
        '一个完善的、 合适的信息安全体系不仅可以在信息安全事故发生后能够及时采取有效的措施， 防止信息安全事故带来巨大的损失， 更重要的是信息安全体系能够预防和避免大多数的信息安全事件的发生。',
      introduceList: [
        {
          id: 1,
          title: '规划',
          name: 'PLAN',
          img: require('@/assets/securityServices/planning5.png'),
          list: ['现状调研', '安全风险识别', '安全规划与设计']
        },
        {
          id: 2,
          title: '实施',
          name: 'DO',
          img: require('@/assets/securityServices/planning6.png'),
          list: [
            '关键风险控制',
            '安全技术策略设计',
            '安全管理体系设计',
            '安全运维体系设计',
            '安全集成实施',
            '安全加固'
          ]
        },
        {
          id: 3,
          title: '检查',
          name: 'CHECK',
          img: require('@/assets/securityServices/planning7.png'),
          list: ['系统上线前安全检查', '定期安全评估', '等级保护评估']
        },
        {
          id: 4,
          title: '改进',
          name: 'ACTION',
          img: require('@/assets/securityServices/planning8.png'),
          list: [
            '调整安全规划',
            '修正安全技术策略',
            '修正安全管理策略',
            '风险控制与应急响应'
          ]
        }
      ],
      fwjzList: [
        {
          id: 1,
          content:
            '建立满足国际标准及国家监管要求，并适应组织自身管理特点的信息安全管理体系；'
        },
        {
          id: 2,
          content:
            '提升主动防范信息技术相关安全风险的能力，保障组织运营的安全；'
        },
        {
          id: 3,
          content: '形成体系的监督、 检查机制，建立可自我改进和完善的管理体系；'
        },
        {
          id: 4,
          content:
            '提升组织内部全员的安全意识， 在组织内部形成信息安全文化氛围，以更有效地推动信息安全管理工作的待续改进；'
        },
        {
          id: 5,
          content: '对组织的关键信息资产进行全面系统的保护， 维持竞争优势；'
        },
        {
          id: 6,
          content:
            '在信息系统受到侵袭时， 确保业务持续开展并将损失降到最低程度；'
        },
        {
          id: 7,
          content:
            '促使管理层贯彻信息安全管理体系， 强化员工的信息安全意识，规范组织信息安全行为；'
        },
        {
          id: 8,
          content: '使组织的生意伙伴和客户对组织充满信心；'
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.costs {
  width: 100%;
  margin-top: 110px;
  .content_A {
    width: 70%;
    margin: 0 auto;
    div {
      font-size: 24px;
      font-weight: 400;
      color: #333333;
      line-height: 40px;
    }
    img {
      width: 60%;
      text-align: center;
      display: flex;
      margin: 109px auto 103px;
    }
    .content_img {
      border: 5px dashed #5782e3;
      border-radius: 10px;
      margin-top: 37px;
      .bg_img {
        width: 90%;
        display: flex;
        justify-content: space-around;
        margin: 0 auto;
        div {
          width: 28%;
          min-height: 58px;
          background-image: url('~@/assets/securityServices/planning1.png');
          background-size: 100% 100%;
          margin: 52px auto;
          text-align: center;

          font-size: 28px;
          font-weight: bold;
          color: #ffffff;
          line-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        div:nth-child(2) {
          background-image: url('~@/assets/securityServices/planning2.png');
          background-size: 100% 100%;
        }
        div:nth-child(3) {
          background-image: url('~@/assets/securityServices/planning2.png');
          background-size: 100% 100%;
        }
      }
    }
  }
  .content_P {
    width: 70%;
    margin: 77px auto 125px;
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
}
.bg_color {
  background: #fafbff;
  padding: 68px 0 125px 0;
}
.introduces {
  width: 100%;
  margin-top: 82px;
  background: #fafbff;
  padding-top: 68px;
  padding-bottom: 128px;

  .title {
    width: 80%;
    margin: 0 auto;
    font-size: 20px;
  }
  .lists {
    width: 70%;
    margin: 0 auto;
    margin-top: 66px;
    display: flex;
    justify-content: space-between;

    .list {
      width: 28%;
      margin-top: 30px;
      margin: 0 1%;
      background: #fff;
      box-shadow: 0 0 50px #ddefff;

      .item_list {
        width: 100%;
        .img {
          text-align: center;
          padding-top: 61px;
          img {
            width: 90px;
            height: 90px;
          }
        }
        .title {
          font-size: 28px;
          font-weight: bold;
          color: #333333;
          line-height: 40px;
          text-align: center;
          margin-top: 37px;
        }
        .line {
          font-size: 28px;
          font-weight: bold;
          color: #568fe8;
          line-height: 40px;
          margin-top: 23px;
          text-align: center;
        }
        .content {
          min-height: 300px;
          margin: 0 auto;
          width: 80%;
          margin-top: 27px;

          div {
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
            text-align: center;
          }
        }
      }
    }
  }
}
@media (min-width: 1200px)and (max-width: 1350px) {
  .costs .content_A div{
    font-size: 20px;
  }

  .costs .content_P{
    font-size: 20px;
  }
  .introduces .lists .list .item_list .content div{
    font-size: 20px;
  }
}
@media screen and (min-width: 1300px) and (max-width: 1500px){
   .introduces .lists .list .item_list .content div,
   .costs .content_A div,
   .costs .content_P,
   .introduces .lists .list .item_list .content div{
    font-size: 22px;
   }
}
</style>
